<template>
  <div class="main-info">
    <div class="title">认证信息</div>
    <div class="tips" v-if="registrationInfo.auditStatus >= 0">
      认证状态：<span class="status-info" :class="{
          'status-info2': registrationInfo.auditStatus == 1,
          'status-info1': registrationInfo.auditStatus == 2,
          'status-info3': registrationInfo.auditStatus == 3,
        }">
        <img src="@static/images/authentication/n.png" v-if="
            registrationInfo.auditStatus == 0 ||
            registrationInfo.auditStatus == 4
          " alt="" />
        <img src="@static/images/authentication/w.png" v-if="registrationInfo.auditStatus == 1" alt="" />
        <img src="@static/images/authentication/s.png" v-if="registrationInfo.auditStatus == 2" alt="" />
        <img src="@static/images/authentication/e.png" v-if="registrationInfo.auditStatus == 3" alt="" />

        {{ all.AUDIT_STATUS[registrationInfo.auditStatus] }}
        {{
          registrationInfo.auditStatus == 3 ? registrationInfo.remark : ""
        }}</span>
      <span class="status-text" v-if="registrationInfo.auditStatus == 0">您的账号信息还未认证，未认证账号将无法出单与提现，请尽快认证</span>
      <span class="status-text" v-if="registrationInfo.auditStatus == 1">我们将在1-2个工作日内完成认证审核；认证中不允许修改信息，如有特殊情况需要修改，请联系您的商务经理或客服（400-8788-100）</span>
      <span class="status-text" v-if="registrationInfo.auditStatus == 2">认证后不可在线更改主体信息及财务信息，如需修改请联系商务经理或客服（400-8788-100）</span>
      <span class="status-text" v-if="registrationInfo.auditStatus == 3">请重新提交认证信息。未认证账号将无法出单与提现，请尽快认证</span>
    </div>
    <div class="content-box">
      <div>
        <div class="top-title">
          <span class="item-title">主体信息</span>
          <el-button type="warning" size="small" class="btn" v-show="
              !editStatus &&
              registrationInfo.mechanUserType == 1 &&
              (registrationInfo.auditStatus == 0 ||
                registrationInfo.auditStatus == 3)
            " @click="edit">编辑</el-button>
          <el-button type="warning" size="small" class="btn" v-show="editStatus" @click="save(1)">保存</el-button>
          <el-button type="warning" plain size="small" class="btn" v-show="editStatus" @click="editStatus = false">取消</el-button>
        </div>
        <div>
          <!-- 企业信息 -->
          <div class="content content-info" v-if="!editStatus && registrationInfo.mechanUserType == 1">
            <div class="item">
              <span class="lab">主体类型：</span>
              <span class="val">{{
                registrationInfo.mechanUserType == 1 ? "企业" : "个人"
              }}</span>
            </div>
            <div class="item">
              <span class="lab">主体简称：</span>
              <span class="val">{{ registrationInfo.shortName }}</span>
            </div>
            <div class="item">
              <span class="lab">主体全称：</span>
              <span class="val">{{ registrationInfo.name }}</span>
            </div>
            <div class="item" v-if="registrationInfo.isLicensed==1">
              <span class="lab">公司类型：</span>
              <span class="val" v-if="registrationInfo.companyType==1">总公司</span>
              <span class="val" v-if="registrationInfo.companyType==2">分公司</span>
            </div>
            <div class="item">
              <span class="lab">行业：</span>
              <span class="val">{{ all.MECHAN_TYPE[registrationInfo.mechanType] }}</span>
            </div>
            <div class="item">
              <span class="lab">所在省市：</span>
              <span class="val">{{ registrationInfo.province
                }}{{ registrationInfo.city }}</span>
            </div>
            <div class="item">
              <span class="lab">详细地址：</span>
              <span class="val">{{
                registrationInfo.address ? registrationInfo.address : "-"
              }}</span>
            </div>
            <div class="item">
              <span class="lab">联系人姓名：</span>
              <span class="val">{{ registrationInfo.toucherName }}</span>
            </div>
            <div class="item">
              <span class="lab">联系人手机号：</span>
              <span class="val">{{ registrationInfo.toucherMobile }}</span>
            </div>
            <div class="item">
              <span class="lab">统一社会信用代码：</span>
              <span class="val">{{
                registrationInfo.businessLicenseNo
                  ? registrationInfo.businessLicenseNo
                  : "-"
              }}</span>
            </div>
            <div class="item">
              <span class="lab">营业执照图片：</span>
              <el-image style="width: 100px; height: 100px" v-if="
                  registrationInfo.businessLicenseImgList &&
                  registrationInfo.businessLicenseImgList.length > 0
                " :src="registrationInfo.businessLicenseImg" :preview-src-list="[registrationInfo.businessLicenseImg]">
              </el-image>
              <span class="val" v-else>-</span>
            </div>
            <div class="item" v-if="registrationInfo.companyType==1&&registrationInfo.isLicensed==1">
              <span class="lab">中介许可证：</span>
              <el-image style="width: 100px; height: 100px" v-if="
                  registrationInfo.intermediaryLicenseImgList &&
                  registrationInfo.intermediaryLicenseImgList.length > 0
                " :src="registrationInfo.intermediaryLicenseImg" :preview-src-list="[registrationInfo.intermediaryLicenseImg]">
              </el-image>
              <span class="val" v-else>-</span>
            </div>
          </div>
          <!-- 企业信息修改 -->
          <div class="content" v-if="editStatus && registrationInfo.mechanUserType == 1">
            <div class="item">
              <span class="lab">主体类型：</span>
              <span>{{
                registrationInfo.mechanUserType == 1 ? "企业" : "个人"
              }}</span>
            </div>
            <div class="item">
              <span class="lab">主体简称：</span>
              <span>{{ registrationInfo.shortName }}</span>
            </div>

            <el-form ref="form" label-width="170px" label-position="left">
              <el-form-item label="主体全称：" class="bjitem">
                <el-input type="text" v-model="editForm.name"></el-input>
              </el-form-item>
              <el-form-item label="公司类型：" class="bjitem">
                <el-select class="select-item" v-model="editForm.companyType" placeholder="请选择" filterable clearable>
                  <el-option value="1" label="总公司"></el-option>
                  <el-option value="2" label="分公司"></el-option>
                </el-select>
              </el-form-item>
              <div class="item">
                <span class="lab">行业：</span>
                <span>{{ all.MECHAN_TYPE[registrationInfo.mechanType] }}</span>
              </div>
              <el-form-item label="所在省市：" class="bjitem">
                <div class="address-select">
                  <el-select class="select-item" v-model="editForm.province" placeholder="省份" filterable clearable @change="provinceChange">
                    <el-option v-for="(item, i) in provinces" :value="item.name" :key="i"></el-option>
                  </el-select>
                  <el-select class="select-item" v-model="editForm.city" placeholder="城市" filterable clearable>
                    <el-option v-for="(item, i) in citys" :value="item.name" :key="i"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="详细地址：" class="bjitem">
                <el-input type="text" v-model="editForm.address"></el-input>
              </el-form-item>
              <el-form-item label="联系人姓名：" class="bjitem">
                <el-input type="text" v-model="editForm.toucherName"></el-input>
              </el-form-item>
              <el-form-item label="联系人手机号：" class="bjitem">
                <el-input type="text" v-model="editForm.toucherMobile"></el-input>
              </el-form-item>
              <el-form-item label="验证码：" class="bjitem" v-if="registrationInfo.isFirst">
                <el-input type="text" v-model="editForm.validateCode" class="code-input" placeholder="请输入验证码">
                  <span slot="suffix" @click="getcode('noMobile')" v-bind:class="getcodeflage ? 'codebtn' : 'huibtn'">{{ getcodetext }}</span>
                </el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码：" class="bjitem">
                <el-input type="text" v-model="editForm.businessLicenseNo"></el-input>
              </el-form-item>
              <el-form-item label="营业执照图片：" class="bjitem" :class="{ 'content-info': editForm.businessLicenseImgList.length }">
                <el-upload :action="$config.api_root + '/resmgr/upload'" :file-list="editForm.businessLicenseImgList" list-type="picture-card" :on-preview="handlePictureCardPreview" 
                :on-remove="(file,fileList) => handleRemove('businessLicenseImg')"
                :on-success="(res) => uploadSuccess(res, 'businessLicenseImg')" :before-upload="beforeUpload" :limit="1">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="中介许可证：" class="bjitem" :class="{ 'content-info': editForm.intermediaryLicenseImgList.length }" 
                v-if="editForm.companyType==1&&registrationInfo.isLicensed==1">
                <el-upload :action="$config.api_root + '/resmgr/upload'" :file-list="editForm.intermediaryLicenseImgList" list-type="picture-card" :on-preview="handlePictureCardPreview" 
                :on-remove="(file,fileList) => handleRemove('intermediaryLicenseImg')"
                :on-success="(res) => uploadSuccess(res, 'intermediaryLicenseImg')" :before-upload="beforeUpload" :limit="1">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <!-- 个人信息 -->
          <div class="content" v-if="registrationInfo.mechanUserType != 1">
            <div class="item">
              <span class="lab">主体类型：</span>
              <span>{{
                registrationInfo.mechanUserType == 1 ? "企业" : "个人"
              }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">主体简称：</span>
              <span>{{ registrationInfo.shortName }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">主体全称：</span>
              <span>{{ registrationInfo.name }}</span>
            </div>
            <div class="item">
              <span class="lab">姓名：</span>
              <span>{{ registrationInfo.toucherName }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">性别：</span>
              <span>{{ registrationInfo.sex }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">民族：</span>
              <span>{{ registrationInfo.nation }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">政治面貌：</span>
              <span>{{ registrationInfo.politicalOutlook }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">最高学历：</span>
              <span>{{ registrationInfo.education }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">是否从事过保险相关行业：</span>
              <span>{{ registrationInfo.policyExp }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">主要收入来源：</span>
              <span>{{ registrationInfo.incomeRes }}</span>
            </div>
            <div class="item">
              <span class="lab">行业：</span>
              <span>{{ all.MECHAN_TYPE[registrationInfo.mechanType] }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">当前工作：</span>
              <span>{{ registrationInfo.curWork }}</span>
            </div>
            <div class="item">
              <span class="lab">所在省市：</span>
              <span>{{ registrationInfo.province }}</span>
              <span>{{ registrationInfo.city }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">常住地址：</span>
              <span>{{ registrationInfo.permanentWork }}</span>
            </div>
            <div class="item">
              <span class="lab">手机号：</span>
              <span>{{ registrationInfo.toucherMobile }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">执业证号：</span>
              <span>{{ registrationInfo.certificateNo }}</span>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">身份证头像面：</span>
              <el-image style="width: 100px; height: 100px" :src="registrationInfo.cardFront" :preview-src-list="[registrationInfo.cardFront]">
              </el-image>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">身份证国徽面：</span>
              <el-image style="width: 100px; height: 100px" :src="registrationInfo.cardBack" :preview-src-list="[registrationInfo.cardBack]">
              </el-image>
            </div>
            <div class="item" v-if="registrationInfo.auditStatus == 2">
              <span class="lab">白底登记照：</span>
              <el-image style="width: 100px; height: 100px" :src="registrationInfo.photo" :preview-src-list="[registrationInfo.photo]">
              </el-image>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="top-title">
          <span class="item-title" v-if="
              registrationInfo.mechanUserType == 1 ||
              (registrationInfo.mechanUserType != 1 &&
                registrationInfo.auditStatus == 2)
            ">财务信息</span>
          <el-button type="warning" size="small" class="btn" @click="fianceEdit" v-show="
              !fianceEditStatus &&
              registrationInfo.mechanUserType == 1 &&
              (registrationInfo.auditStatus == 0 ||
                registrationInfo.auditStatus == 3)
            ">编辑</el-button>
          <el-button type="warning" size="small" class="btn" @click="save(2)" v-show="fianceEditStatus">保存</el-button>
          <el-button type="warning" plain size="small" class="btn" @click="fianceEditStatus = false" v-show="fianceEditStatus">取消</el-button>
        </div>
        <div>
          <div class="content" v-if="
              (registrationInfo.mechanUserType == 1 && !fianceEditStatus) ||
              (registrationInfo.mechanUserType != 1 &&
                registrationInfo.auditStatus == 2)
            ">
            <div class="item">
              <span class="lab">账号类型：</span>
              <span class="val">{{
                registrationInfo.mechanUserType == 1 ? "企业账号" : "个人账号"
              }}</span>
            </div>
            <div class="item">
              <span class="lab">户名：</span>
              <span class="val">{{ registrationInfo.bankUserName || "-" }}</span>
            </div>
            <div class="item">
              <span class="lab">银行账号：</span>
              <span class="val">{{ registrationInfo.bankAccount || "-" }}</span>
            </div>
            <div class="item">
              <span class="lab">开户银行：</span>
              <span class="val">{{
                registrationInfo.bankType ? registrationInfo.bankType : "-"
              }}</span>
            </div>
            <div class="item">
              <span class="lab">支行名称：</span>
              <span class="val">{{ registrationInfo.bankBranchName || "-" }}</span>
            </div>
            <div class="item" v-if="registrationInfo.mechanUserType == 1">
              <span class="lab">是否开具发票：</span>
              <span class="val">{{ registrationInfo.hasReceipt ? "是" : "否" }}</span>
            </div>
            <div class="item" v-if="
                registrationInfo.mechanUserType == 1 &&
                registrationInfo.hasReceipt
              ">
              <span class="lab">发票类型：</span>
              <span class="val">{{
                all.MECHAN_TAX_LEVEL[registrationInfo.mechanTaxLevel]
              }}</span>
            </div>
            <div class="item" v-if="
                registrationInfo.mechanUserType == 1 &&
                registrationInfo.hasReceipt
              ">
              <span class="lab">发票税点：</span>
              <span class="val">{{ registrationInfo.taxPoint || "-" }}</span>
            </div>
          </div>
          <div class="content" v-if="registrationInfo.mechanUserType == 1 && fianceEditStatus">
            <div class="item">
              <span class="lab">账号类型：</span>
              <span>{{
                registrationInfo.mechanUserType == 1 ? "企业账号" : "个人账号"
              }}</span>
            </div>
            <el-form ref="form" label-width="170px" label-position="left">
              <el-form-item label="户名：" class="bjitem">
                <el-input type="text" v-model="fianceEditForm.bankUserName" placeholder="请输入户名"></el-input>
              </el-form-item>
              <el-form-item label="银行账号：" class="bjitem">
                <el-input type="text" v-model="fianceEditForm.bankAccount" placeholder="请输入银行账号" @blur="getBankInfo(fianceEditForm.bankAccount)"></el-input>
              </el-form-item>
              <el-form-item label="开户银行：" class="bjitem">
                <el-input type="text" v-model="fianceEditForm.bankType" placeholder="请输入开户银行"></el-input>
              </el-form-item>
              <el-form-item label="支行名称：" class="bjitem">
                <el-input type="text" v-model="fianceEditForm.bankBranchName" placeholder="请输入支行名称"></el-input>
              </el-form-item>
              <el-form-item label="是否开具发票：" class="bjitem">
                <span>{{ fianceEditForm.hasReceipt ? "是" : "否" }}</span>
              </el-form-item>
              <el-form-item label="发票类型：" class="bjitem" v-if="fianceEditForm.hasReceipt">
                <el-select v-model="fianceEditForm.mechanTaxLevel" placeholder="请选择发票类型" @change="taxChange">
                  <el-option v-for="(item, key) in all.MECHAN_TAX_LEVEL" :key="key" :label="item" :value="key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发票税点：" class="bjitem" v-if="fianceEditForm.hasReceipt">
                <span>{{ fianceEditForm.taxPoint }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-box" v-if="
        registrationInfo.mechanUserType == 1 &&
        (registrationInfo.auditStatus == 0 || registrationInfo.auditStatus == 3)
      ">
      <el-button type="warning" size="small" class="submit-btn" @click="save(3)">提交认证</el-button>
    </div>
    <div class="tip-box" v-if="registrationInfo.mechanUserType != 1" :class="{ 'border-top': registrationInfo.auditStatus != 2 }">
      <!-- 个人认证提示 -->
      <div v-if="registrationInfo.auditStatus == 0">
        请扫描二维码完善个人信息，并进行身份核验，凤栖云服将为您申请保险执业资格证
      </div>
      <div v-if="registrationInfo.auditStatus == 3">
        请扫描二维码修改信息，重新提交签约申请
      </div>
      <div v-if="registrationInfo.auditStatus == 1">
        扫描二维码可查看您提交的签约信息
      </div>
      <!-- 完善、修改、认证中查看签约信息 -->
      <canvas id="code" v-if="
          registrationInfo.auditStatus == 0 ||
          registrationInfo.auditStatus == 1 ||
          registrationInfo.auditStatus == 3
        "></canvas>
      <div class="follow" v-if="registrationInfo.auditStatus == 1">
        扫描凤栖云服公众号二维码将账号与您的微信绑定，即可在公众号实时接收认证结果、认证通过后可接收平台公告以及出单通知等
      </div>
      <!-- 凤栖公众号二维码图片 -->
      <img :src="codeUrl" @click="getWechatCode" title="点击刷新" v-if="registrationInfo.auditStatus == 1" />
    </div>
    <result-dialog ref="resultDialog" @getWechatCode="getWechatCode" :codeUrl="codeUrl"></result-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
//当前实例组件
// import config from "./maininfo.config";
import reg from '../../api/regulars.js'
var QRCode = require('qrcode')
import city from '../../api/city.js'
import resultDialog from './components/resultDialog'
export default {
  data() {
    return {
      userInfo: {},
      registrationInfo: {}, //注册信息
      editForm: {}, //注册信息编辑表单
      fianceEditForm: {}, //财务信息编辑表单
      all: {}, //字典
      editStatus: false, //企业注册信息编辑状态
      getcodetext: '获取验证码',
      getcodeflage: true,
      fianceEditStatus: false, //财务编辑状态
      provinces: city.provinces,
      citys: [],
      codeUrl: '',
      dialogVisible: false, //图片查看
      dialogImageUrl: '',
      timer: '',
      mechanTaxLevels: [], //发票类型
      contractId: '',
    }
  },
  components: { resultDialog },
  created() {
    this.getState()
    this.userInfo = this.$tools.getLocal('userinfo')
    this.getWechatCode()
  },
  destroyed() {
    this.getcodetext = '获取验证码'
    this.getcodeflage = true
    clearTimeout(this.timer)
  },
  methods: {
    //获取状态
    getState() {
      this.$tools.getall(this.setAll)
    },
    setAll(data) {
      this.all = data
    },
    //机构注册信息编辑
    edit() {
      this.editForm = {
        name: this.registrationInfo.name,
        province: this.registrationInfo.province,
        city: this.registrationInfo.city,
        address: this.registrationInfo.address,
        toucherName: this.registrationInfo.toucherName,
        toucherMobile: this.registrationInfo.toucherMobile,
        businessLicenseNo: this.registrationInfo.businessLicenseNo,
        businessLicenseImg: this.registrationInfo.businessLicenseImg,
        companyType: this.registrationInfo.companyType,
        intermediaryLicenseImg: this.registrationInfo.intermediaryLicenseImg,
        validateCode: '',
      }
      if (this.registrationInfo.businessLicenseImg) {
        this.editForm.businessLicenseImgList =
          this.registrationInfo.businessLicenseImgList
      } else {
        this.editForm.businessLicenseImgList = []
      }
      if (this.registrationInfo.intermediaryLicenseImg) {
        this.editForm.intermediaryLicenseImgList =
          this.registrationInfo.intermediaryLicenseImgList
      } else {
        this.editForm.intermediaryLicenseImgList = []
      }
      this.getCity()
      this.editStatus = true
    },
    //机构注册信息编辑
    fianceEdit() {
      this.fianceEditForm = {
        bankUserName: this.registrationInfo.bankUserName,
        bankAccount: this.registrationInfo.bankAccount,
        bankType: this.registrationInfo.bankType,
        bankBranchName: this.registrationInfo.bankBranchName, //支行名称
        hasReceipt: this.registrationInfo.hasReceipt,
        mechanTaxLevel: this.registrationInfo.mechanTaxLevel,
        taxPoint: this.registrationInfo.taxPoint,
      }
      this.fianceEditStatus = true
    },
    //机构注册信息保存、提交认证
    save(type) {
      let params = {}
      if (type == 1 || (type == 3 && this.editStatus)) {
        //主体信息编辑保存、提交主体编辑状态
        if (!this.editForm.name) {
          this.$message.error('请填写主体全称')
          return
        }
        if (!this.editForm.province) {
          this.$message.error('请选择省')
          return
        }
        if (!this.editForm.city) {
          this.$message.error('请选择市')
          return
        }
        if (!this.editForm.address) {
          this.$message.error('请填写详细地址')
          return
        }
        if (!this.editForm.toucherName) {
          this.$message.error('请填写联系人姓名')
          return
        }
        if (!reg.isName(this.editForm.toucherName)) {
          this.$message.error('请填写正确的联系人姓名')
          return
        }
        if (!this.editForm.toucherMobile) {
          this.$message.error('请填写联系人手机号')
          return
        }
        if (
          !reg.isPhone(this.editForm.toucherMobile) &&
          this.editForm.toucherMobile.indexOf('*') == -1
        ) {
          this.$message.error('请填写正确的联系人手机号')
          return
        }
        if (this.registrationInfo.isFirst) {
          if (!this.editForm.validateCode) {
            this.$message.error('首次认证，请填写手机验证码')
            return
          }
        }
        if (!this.editForm.businessLicenseNo) {
          this.$message.error('请填写统一社会信用代码')
          return
        }
        if (
          !reg.isBusinessLicenseNo(this.editForm.businessLicenseNo) &&
          this.editForm.businessLicenseNo.indexOf('*') == -1
        ) {
          this.$message.error('请填写正确的统一社会信用代码')
          return
        }
        if (!this.editForm.businessLicenseImg) {
          this.$message.error('请上传营业执照图片')
          return
        }
        // 持牌渠道额外校验
        if(this.registrationInfo.isLicensed==1){
          if(!this.editForm.companyType){
            this.$message.error('请选择公司类型')
            return
          }
          if(!this.editForm.intermediaryLicenseImg && this.editForm.companyType == 1){//总公司校验
            this.$message.error('请上传中介许可证图片')
            return
          }
        }
        // if (type == 1) {
        //   params = this.editForm;
        // }
        if (type == 1 || (type == 3 && !this.fianceEditStatus)) {
          params = Object.assign(this.registrationInfo, this.editForm)
        }
      }
      if (type == 3 && !this.editStatus) {
        //提交 主体信息非编辑状态
        if (!this.registrationInfo.name) {
          this.$message.error('请填写主体全称')
          return
        }
        if (!this.registrationInfo.province) {
          this.$message.error('请选择省')
          return
        }
        if (!this.registrationInfo.city) {
          this.$message.error('请选择市')
          return
        }
        if (!this.registrationInfo.address) {
          this.$message.error('请填写详细地址')
          return
        }
        if (!this.registrationInfo.toucherName) {
          this.$message.error('请填写联系人姓名')
          return
        }
        if (!reg.isName(this.registrationInfo.toucherName)) {
          this.$message.error('请填写正确的联系人姓名')
          return
        }
        if (!this.registrationInfo.toucherMobile) {
          this.$message.error('请填写联系人手机号')
          return
        }
        if (
          !reg.isPhone(this.registrationInfo.toucherMobile) &&
          this.registrationInfo.toucherMobile.indexOf('*') == -1
        ) {
          this.$message.error('请填写正确的联系人手机号')
          return
        }
        if (this.registrationInfo.isFirst) {
          this.$message.error('首次认证，请编辑填写手机验证码')
        }
        if (!this.registrationInfo.businessLicenseNo) {
          this.$message.error('请填写统一社会信用代码')
          return
        }
        if (
          !reg.isBusinessLicenseNo(this.registrationInfo.businessLicenseNo) &&
          this.registrationInfo.businessLicenseNo.indexOf('*') == -1
        ) {
          this.$message.error('请填写正确的统一社会信用代码')
          return
        }
        if (!this.registrationInfo.businessLicenseImg) {
          this.$message.error('请上传营业执照图片')
          return
        }
      }
      if (type == 2 || (type == 3 && this.fianceEditStatus)) {
        //财务信息编辑保存、提交财务编辑状态
        if (!this.fianceEditForm.bankUserName) {
          this.$message.error('请填写户名')
          return
        } else {
          //户名需与主体全称或联系人姓名保持一致
          if (type == 3 && this.editStatus) {
            if (
              this.fianceEditForm.bankUserName != this.editForm.name &&
              this.fianceEditForm.bankUserName != this.editForm.toucherName
            ) {
              this.$message.error('户名需与主体全称或联系人姓名保持一致')
              return
            }
          } else {
            if (
              this.fianceEditForm.bankUserName != this.registrationInfo.name &&
              this.fianceEditForm.bankUserName !=
                this.registrationInfo.toucherName
            ) {
              this.$message.error('户名需与主体全称或联系人姓名保持一致')
              return
            }
          }
        }
        if (!reg.isCh(this.fianceEditForm.bankUserName)) {
          this.$message.error('填写正确的户名')
          return
        }
        if (!this.fianceEditForm.bankAccount) {
          this.$message.error('请填写银行账号')
          return
        }
        if (
          !reg.isAllNum(this.fianceEditForm.bankAccount) &&
          this.fianceEditForm.bankAccount.indexOf('*') == -1
        ) {
          this.$message.error('请填写正确的银行账号')
          return
        }
        if (!this.fianceEditForm.bankType) {
          this.$message.error('请填写开户银行')
          return
        }
        if (!this.fianceEditForm.bankBranchName) {
          this.$message.error('请填写支行名称')
          return
        }
        if (this.fianceEditForm.hasReceipt) {
          if (!this.fianceEditForm.mechanTaxLevel) {
            this.$message.error('请选择发票类型')
            return
          }
          // if (!this.fianceEditForm.taxPoint) {
          //   this.$message.error("请填写发票税点");
          //   return;
          // }
        }
        // if (type == 2) {
        //   params = this.fianceEditForm;
        // }
        if (type == 2 || (type == 3 && !this.editStatus)) {
          params = Object.assign(this.registrationInfo, this.fianceEditForm)
        }
      }
      if (type == 3 && !this.fianceEditStatus) {
        //提交 财务非编辑状态
        if (!this.registrationInfo.bankUserName) {
          this.$message.error('请填写户名')
          return
        } else {
          //户名需与主体全称或联系人姓名保持一致
          if (type == 3 && this.editStatus) {
            if (
              this.registrationInfo.bankUserName != this.editForm.name &&
              this.registrationInfo.bankUserName != this.editForm.toucherName
            ) {
              this.$message.error('户名需与主体全称或联系人姓名保持一致')
              return
            }
          } else {
            if (
              this.registrationInfo.bankUserName !=
                this.registrationInfo.name &&
              this.registrationInfo.bankUserName !=
                this.registrationInfo.toucherName
            ) {
              this.$message.error('户名需与主体全称或联系人姓名保持一致')
              return
            }
          }
        }
        if (!reg.isCh(this.registrationInfo.bankUserName)) {
          this.$message.error('请填写正确的户名')
          return
        }
        if (!this.registrationInfo.bankAccount) {
          this.$message.error('请填写银行账号')
          return
        }
        if (
          !reg.isAllNum(this.registrationInfo.bankAccount) &&
          this.registrationInfo.bankAccount.indexOf('*') == -1
        ) {
          this.$message.error('请填写正确的银行账号')
          return
        }
        if (!this.registrationInfo.bankType) {
          this.$message.error('请选择开户银行')
          return
        }
        if (!this.registrationInfo.bankBranchName) {
          this.$message.error('请填写支行名称')
          return
        }
        if (this.registrationInfo.hasReceipt) {
          if (!this.registrationInfo.mechanTaxLevel) {
            this.$message.error('请选择发票类型')
            return
          }
          // if (!this.registrationInfo.taxPoint) {
          //   this.$message.error("请填写发票税点");
          //   return;
          // }
        }
      }
      if (type == 3 && !this.editStatus && !this.fianceEditStatus) {
        //提交 都是未编辑状态
        params = this.registrationInfo
      }
      if (type == 3 && this.editStatus && this.fianceEditStatus) {
        //提交 都是编辑状态
        params = Object.assign(
          this.registrationInfo,
          this.editForm,
          this.fianceEditForm
        )
      }
      if (params.bankBranchName) {
        params.bankAddress = params.bankBranchName
        delete params.bankBranchName
      }
      if (params.toucherMobile && params.toucherMobile.indexOf('*') != -1) {
        delete params.toucherMobile
      }
      if (
        params.businessLicenseNo &&
        params.businessLicenseNo.indexOf('*') != -1
      ) {
        delete params.businessLicenseNo
      }
      if (params.bankAccount && params.bankAccount.indexOf('*') != -1) {
        delete params.bankAccount
      }
      if (!this.registrationInfo.isFirst && !params.validateCode) {
        delete params.validateCode
      }
      delete params.businessLicenseImgList
      delete params.intermediaryLicenseImgList
      params.id = this.userInfo.mechanId
      params.code = this.registrationInfo.code
      // console.log(params);
      // return;
      this.$http({
        url:
          '/master/mechan/mechanAuthenticate?type=' +
          type +
          (this.registrationInfo.contractId
            ? '&contractId=' + this.registrationInfo.contractId
            : ''),
        type: 'post',
        params: params,
      }).then((res) => {
        if (type == 1) {
          this.editStatus = false
          this.$message.success('保存成功')
        }
        if (type == 2) {
          this.fianceEditStatus = false
          this.$message.success('保存成功')
        }
        if (type == 3) {
          this.$refs.resultDialog.dialogVisible = true
          this.editStatus = false
          this.fianceEditStatus = false
        }
        this.getInfo()
      })
    },
    provinceChange() {
      this.citys = []
      this.editForm.city = ''
      this.getCity()
    },
    getCity() {
      for (var item of this.provinces) {
        if (item.name === this.editForm.province) {
          this.citys = item.cities
        }
      }
    },
    //发送验证码点击事件
    getcode() {
      let phone = this.editForm.toucherMobile
      if (phone) {
        if (reg.isPhone(phone)) {
          if (this.getcodeflage) {
            this.getcodeflage = false
            this.sendCode(phone)
          }
        } else {
          this.$message.error('请输入正确的手机号')
        }
      } else {
        this.$message.error('请输入手机号')
      }
    },
    //获取验证码
    async sendCode() {
      const signNumber = await this.$tools.phoneSignature()
      let phone = this.editForm.toucherMobile
      let ajaxUrl = '/master/user/sendCode'
      let params = {
        mobile: phone,
        signature: signNumber,
      }
      this.$http({
        url: ajaxUrl,
        type: 'post',
        params: params,
      }).then((res) => {
        this.getcodetext = 60
        this.timer = setInterval(() => {
          if (this.getcodetext == '获取验证码') {
            return
          }
          this.getcodetext--
          if (this.getcodetext == 0) {
            this.getcodeflage = true
            clearInterval(this.timer)
            this.getcodetext = '获取验证码'
          }
        }, 1000)
      })
    },
    getBankInfo(num) {
      if (!num) {
        return
      }
      this.$http({
        url: '/insure/getBankInfo?cardNumber=' + num,
        type: 'post',
      })
        .then((data) => {
          if (data.data.bankName) {
            this.fianceEditForm.bankType = data.data.bankName
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    beforeUpload(file) {
      var type = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = type === 'jpg'
      const extension1 = type === 'jpeg'
      const extension2 = type === 'png'
      // const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension1 && !extension2) {
        this.$message.error('请上传jpg/jpeg/png格式图片！')
      }
      // if(!isLt2M) {
      //     this.$message.error('上传文件大小不能超过 2MB！');
      // }
      // return (extension || extension1 || extension2) && isLt2M
      return extension || extension || extension2
    },
    // //获取主体信息
    // queryMechanInfo: function () {
    //   var this = this;
    //   this.$http({
    //     url: "/master/mechan/queryMechanInfo",
    //     type: "put",
    //     params: {},
    //   }).then(function (res) {
    //     res.data.toucherMobileBak =
    //       res.data.toucherMobile.substring(0, 3) +
    //       "****" +
    //       res.data.toucherMobile.substring(7);
    //     this.mechanInfo = res.data;
    //   });
    // },
    handleRemove(key) {
      this.editForm[key] = '';
      this.editForm[key+'List'] = [];
      this.$forceUpdate();
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    uploadSuccess(res,key) {
      let img = res.data[0].wwwurl
      this.editForm[key] = img
      this.editForm[key+'List'] = [{
        name:key,
        url:img
      }];
      this.$forceUpdate();
    },
    //获取详情
    getInfo() {
      let url
      // this.userInfo.mechanUserType = 2;
      if (this.userInfo.mechanUserType == 1) {
        //企业
        url = '/master/mechan/read/enterprise/detail'
      } else {
        //个人
        url = '/master/mechan/read/individual/detail'
      }
      this.$http({
        url: url, //
        type: 'get',
        // params: {
        //   id: this.userInfo.mechanId, //个人："1418401264706375680" 企业：'1418531751597281280' '1417006757772963840'
        // },
      }).then((res) => {
        this.registrationInfo = res.data
        // this.registrationInfo.auditStatus = "3";
        // this.registrationInfo.mechanUserType = 2;
        if (this.userInfo.mechanUserType == 1) {
          if (this.registrationInfo.businessLicenseImg) {
            this.registrationInfo.businessLicenseImgList = [
              {
                name: 'businessLicenseImg',
                url: this.registrationInfo.businessLicenseImg,
              },
            ]
          }
          if (this.registrationInfo.intermediaryLicenseImg) {
            this.registrationInfo.intermediaryLicenseImgList = [
              {
                name: 'intermediaryLicenseImg',
                url: this.registrationInfo.intermediaryLicenseImg,
              },
            ]
          }
          console.log(this.registrationInfo.intermediaryLicenseImgList)
        } else {
          if (this.registrationInfo.auditStatus != '2') {
            this.$nextTick(() => {
              let code = document.getElementById('code')
              QRCode.toCanvas(
                code,
                this.registrationInfo.authUrl,
                { width: 155, height: 155 },
                function (error) {
                  if (error) console.error(error)
                  console.log('success!')
                }
              )
            })
          }
        }
      })
    },
    getWechatCode() {
      this.$http({
        url: '/api/wechat/momentCode', //
        type: 'post',
        params: {
          mechanId: this.userInfo.mechanId, //个人："1418401264706375680" 企业：'1418531751597281280''1263681328684965888' this.userInfo.mechanId
          mechanUserId: this.userInfo.id,
        },
      }).then((res) => {
        this.codeUrl = res.data.qrCodeUrl
      })
    },
    taxChange() {
      let arr = [0, 0.03, 0.06, 0.05]
      this.fianceEditForm.taxPoint = arr[this.fianceEditForm.mechanTaxLevel - 1]
    },
  },
  mounted() {
    this.getInfo()
  },
}
</script>
<style lang="scss" scoped>
@import '~@/sass/person/authenticationInformation';
</style>
